import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { OrgNodeType } from '../../entities/org-node-type';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class OrgNodeTypeService {

  private static readonly orgNodeTypeBaseUrl:string = `${Settings.apiUrl}/v1/OrgNodeTypes`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public orgNodeTypes:OrgNodeType[] = [];

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getOrgNodeTypes():Promise<OrgNodeType[]>{

    return this.cachedCallService.invokeSingleCall(
      () => {
        return this.http.get(OrgNodeTypeService.orgNodeTypeBaseUrl)
          .toPromise()
          .then(response => {

            this.orgNodeTypes = response.json().value;

            return this.orgNodeTypes;
          });
      }, "getOrgNodeTypes"
    );
    
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/org-node-type.service.ts